import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showMissingNotificationPrompt } from '~/components/NativePush';
import { isNativeApp } from '~/core/util/device';
import { NativeContext } from '~/core/native/NativeContextProvider';
import { useShouldSuppressPushPrompt } from '~/components/AccountGetsMarried/hooks/useShouldSuppressPushPrompt';

export const useShowMissingNotificationPrompt = () => {
  const dispatch = useDispatch();
  const { shouldShowPushPrompt, notificationsEnabled } = useContext(NativeContext);
  const shouldSuppressPrompt = useShouldSuppressPushPrompt();

  useEffect(() => {
    if (isNativeApp() && !notificationsEnabled && shouldShowPushPrompt && !shouldSuppressPrompt) {
      dispatch(showMissingNotificationPrompt());
    }
  }, [dispatch, notificationsEnabled, shouldShowPushPrompt, shouldSuppressPrompt]);
};
